import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface FinancialSummarySectionProps {
  account: any;
}

const formatCurrency = (amount: number) =>
  (amount || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const FinancialSummarySection: React.FC<FinancialSummarySectionProps> = ({ account }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
      Financial Summary
    </Typography>
    <Stack spacing={1}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Charges:</strong> ${formatCurrency(account.transactionHeader?.charges)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Adjusted Revenue:</strong> $
            {formatCurrency(account.transactionHeader?.adjustedRevenue)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Room Charges:</strong> ${formatCurrency(account.transactionHeader?.roomCharges)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Contractual Adjustments:</strong> $
            {formatCurrency(account.transactionHeader?.contractualAdjustments)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Adjustments:</strong> ${formatCurrency(account.transactionHeader?.adjustments)}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <Box>
          <Typography variant="body2">
            <strong>Insurance Payments:</strong> $
            {formatCurrency(account.transactionHeader?.insurancePayments)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2">
            <strong>Patient Payments:</strong> $
            {formatCurrency(account.transactionHeader?.patientPayments)}
          </Typography>
        </Box>
      </Box>
      <Typography variant="body2">
        <strong>Balance:</strong> ${formatCurrency(account.balance)}
      </Typography>
      <Typography variant="body2">
        <strong>AR Balance:</strong> ${formatCurrency(account.arBalance)}
      </Typography>
    </Stack>
  </Box>
);

export default FinancialSummarySection;
